var _linearGradient, _radialGradient, _radialGradient2, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _linearGradient4, _path6, _linearGradient5, _path7, _linearGradient6, _path8, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaNjQuickDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 60.784,
    y1: 59.803,
    x2: 40.565,
    y2: 3.404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#17175a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#183174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a6aae"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.28 21.09c1.97-.19 3.88.12 5.59.83.27-1.67 1.24-5.88 4.11-7.27 3.62-1.75 10.16-2.03 10.16-2.03s-1.65 6.4-1.42 6.35 15.14-1.7 15.14-1.7l-11.58 12.2s3.16 7.04 3.48 8.2c.32 1.15.32 2.85-.69 4.92S82.21 56.4 82.21 56.4c-3.33-1.2-8.53.21-10.39 3.36l-31.3 3.91s-3.34 2.16-7.6 2.9c-4.25.74-8.88.83-9.51.83-.64 0-1.7-.78-3.53-6.72a89.725 89.725 0 0 1-2.12-8.34c-20.62 3.19-21.85-21.4-4.95-35.83 7.9-6.74 20.06-11.43 34.51-10.26 9.72-9.21 24.78 3.5 17.96 14.84z",
    fill: "url(#a)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 56.993,
    cy: 11.44,
    r: 14.765,
    fx: 55.7,
    fy: 10.751,
    gradientTransform: "matrix(-.3746 .9272 -.738 -.2981 86.782 -37.993)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#d7d7d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#d4d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#d4d4d5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M54.89 6.03c5.03 0 9.12 4.11 9.12 9.17s-4.08 9.17-9.12 9.17-9.12-4.11-9.12-9.17 4.09-9.17 9.12-9.17z",
    fill: "url(#b)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 56.544,
    cy: 13.512,
    r: 7.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6d75c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#a6cf55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#91c54d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#8ac14a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#7fb849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#629e47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#397b43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921,
    stopColor: "#286f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f683d"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.64 13.62c-.66-.47-.66-.39-1.23-.47s-.66-.52-.88-.53l2.16.07c.66.08.85-1.29-.77-2.84-1.62-1.54-2.64-1.82-3.32-1.65s-.33 1.77-.33 1.77c-.19.44.33.28.5.47.16.19.52.27.71.61.19.33.03.44-.19.83s-.08.75-.08.75H59c-.03.01-.47.12-.26.41.22.3.48.5.29.53-.2.03-.39-.1-.37.31.02.42-.06.83 0 1.13.06.31-.02.43-.19.42-.18-.02-.38-.11-.32.41.07.53.04.84-.12.84s-.3 0-.3.21 0 .32-.18.3c-.18-.01-.26-.05-.26.22 0 .18.03.27.05.34-.05-.03-.06-.08-.14-.08-.21-.02-.43-.37-.45-.76-.03-.39-.26-.15-.61-.15s-.11-.34-.44-.43c-.33-.08-.29-.26-.26-.69s.18-.7.57-.68c.38.03.3-.01.52-.47.22-.45.36-.44.61-.52.24-.08.09-.36-.11-.39-.21-.03-.23-.13-.26-.32-.02-.17-.43-.47-.53-.54.02-.07.15-.45-.2-.53-.38-.08.08-.52-.03-.83-.11-.3-.22-.61.19-.66s-.33-.42.13-.72c.47-.29.5-.25.5-.25s-1.32-2.29-3.22-1.6c-1.89.69-3.9 2.65-4.01 3.89-.11 1.25.63 1.72 1.64 1.55l3.02-.58 1.75-.24-1.9.8c-1.07.47-2.87 1.48-3.3 2.86-.44 1.38 1.34 4.25 3.02 4.31 1.11.04 2.99-1.52 3.51-2.43-.15 1.31-.9 2.67-1.91 3.38 0 0-.21.76.79.47.85-.9 1.62-2.61 1.42-4.23.12.09.28.24.47.57.47.79 1.42 1.49 2.04 1.34.63-.15 2.2-1.27 2.43-3.06s-.28-2.67-.94-3.14z",
    fill: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.3 29.31a41.73 41.73 0 0 1 23.94-14.05l-2.01-1.24C17.82 16.89 8.88 23.13 6.3 29.31zm29.45-14.74c2.94-.18 5.91-.05 8.9.38l.44-2.18c-2.46-.37-4.99-.46-7.51-.31l-1.83 2.11zm-8.48 7.83 7.06-1.04c-2.2-2.16-5.92-.58-8.35.42l1.29.62z",
    style: {
      fill: "#a9cd4b"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.77 16.59 1.08 2.6 2.78.02-2.11 1.84.85 2.69-2.38-1.47-2.26 1.64.64-2.74-2.24-1.68 2.77-.23z",
    fill: "#fedb34"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m32.24 10 1.35 2.51 2.79-.38-1.93 2.07 1.23 2.57-2.55-1.22-2.03 1.97.36-2.83-2.48-1.36 2.76-.52z",
    style: {
      fill: "#a9cd4b"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m42.13 7.25.57 1.67 1.74.13-1.39 1.06.42 1.72-1.43-1.01-1.48.93.51-1.69-1.33-1.14 1.74-.03zm-19.46 4.69.73.87 1.1-.27-.59.97.6.98-1.1-.28-.73.87-.09-1.14-1.04-.43 1.04-.43zm4.13 5.07.59.83 1-.16-.6.83.46.92-.96-.33-.72.73.01-1.03-.91-.47.97-.3z",
    fill: "#fedb34"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m20.97 19.06.6.53.74-.31-.31.74.52.62-.79-.08-.42.69-.18-.79-.78-.18.68-.42z",
    style: {
      fill: "#a9cd4b"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 18.466,
    y1: 57.326,
    x2: 18.466,
    y2: 22.481
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3942c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fbb72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#fbba2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#fcc530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fed432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#ffe636"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m23.73 57.33-3.14-10.17-.03-.09-.09.04c-1.8.74-3.61 1.11-5.38 1.11-3.19 0-5.9-1.24-7.64-3.48-1.9-2.45-2.43-5.78-1.5-9.36 1.85-7.11 8.97-12.89 15.88-12.89 3.19 0 5.9 1.24 7.64 3.48 1.9 2.45 2.43 5.78 1.5 9.37-.74 2.86-2.34 5.57-4.62 7.83.72 1.65.77 1.93.77 1.98.01.48-2.17 8.02-3.39 12.18zm-3.75-28.7c-3.32.18-6.58 3.28-7.29 6.91-.35 1.83 0 3.56.98 4.74.84 1.01 2.07 1.57 3.48 1.57.1 0 .2 0 .3-.01.46-.03.94-.11 1.42-.25l.08-.02-.3-.89c-.42-1.22-.76-2.19-.64-3.12.17-1.35 1.85-2.38 2.84-2.88.29-.15.56-.22.79-.22.22 0 .34.07.36.08-.01.01.69 1.36 1.56 3.09l.07.14.08-.13a8.54 8.54 0 0 0 1.03-2.69c.35-1.83 0-3.56-.98-4.74-.84-1.02-2.07-1.58-3.48-1.58-.1-.01-.2-.01-.3 0z",
    fill: "url(#d)",
    style: {
      fillRule: "evenodd"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.84 22.57c3.16 0 5.85 1.23 7.57 3.45 1.88 2.43 2.41 5.73 1.48 9.29-.74 2.84-2.33 5.54-4.59 7.79l-.09.08.05.11.78 1.85c0 .44-1.92 7.16-3.31 11.89l-3.05-9.9-.05-.18-.17.07c-1.78.73-3.58 1.1-5.35 1.1-3.16 0-5.85-1.22-7.57-3.45-1.88-2.43-2.41-5.73-1.48-9.29 1.82-7.06 8.91-12.81 15.78-12.81m-4.69 19.37c.1 0 .2 0 .31-.01.47-.03.96-.11 1.43-.25l.17-.05-.06-.17c-.09-.28-.19-.55-.28-.81-.42-1.21-.75-2.17-.64-3.08.16-1.31 1.82-2.33 2.79-2.81.28-.14.53-.21.76-.21a.73.73 0 0 1 .28.05l1.56 3.07.14.28.16-.27c.51-.87.86-1.79 1.04-2.72.36-1.85 0-3.61-1-4.81-.85-1.04-2.11-1.61-3.55-1.61-.1 0-.2 0-.3.01-3.35.18-6.66 3.31-7.36 6.98-.36 1.85 0 3.61 1 4.81.86 1.03 2.12 1.6 3.55 1.6m4.69-19.54c-6.95 0-14.1 5.8-15.96 12.96C4.02 42.5 8.15 48.3 15.1 48.3c1.83 0 3.66-.4 5.42-1.12l3.22 10.43 3.48-12.48c0-.16-.32-.9-.8-1.92 2.19-2.18 3.87-4.91 4.64-7.87 1.85-7.15-2.28-12.94-9.22-12.94zm-4.69 19.37c-3.11 0-5.06-2.72-4.38-6.21.7-3.6 3.92-6.67 7.21-6.84.1-.01.2-.01.3-.01 3.11 0 5.06 2.72 4.38 6.21-.18.94-.54 1.84-1.02 2.67l-1.59-3.12s-.13-.09-.4-.09c-.2 0-.48.05-.83.23-.82.41-2.7 1.47-2.88 2.94-.15 1.16.39 2.38.92 3.97-.46.14-.93.22-1.4.25h-.31z",
    fill: "#fe5"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 63.429,
    y1: 42.68,
    x2: 63.429,
    y2: 23.665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3942c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#fbb72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#fed432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe636"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M61.41 42.68c-2.33 0-4.34-.88-5.64-2.49-1.37-1.69-1.83-4-1.3-6.49 1.06-4.97 7.21-10.03 12.19-10.03 2.56 0 4.61 1.29 5.94 3.72l-5.02 3.4c-.41-1.15-1.37-1.86-2.52-1.86a3.03 3.03 0 0 0-.59.06c-2 .38-3.78 2.56-3.98 4.87-.09 1.07.2 2.02.81 2.68.49.53 1.16.83 1.88.83 1.14 0 2.26-.71 3.19-1.99.47.4 1.16.94 1.86 1.49l2.04 1.63c-2.29 2.47-5.42 4.03-8.39 4.18h-.47z",
    fill: "url(#e)",
    style: {
      fillRule: "evenodd"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.66 23.58v.17c2.5 0 4.51 1.25 5.83 3.61l-4.87 3.29c-.44-1.12-1.41-1.81-2.56-1.81-.2 0-.4.02-.6.06-2.03.38-3.85 2.6-4.04 4.95-.09 1.09.21 2.06.83 2.74a2.63 2.63 0 0 0 1.94.86c1.14 0 2.27-.69 3.2-1.95l1.8 1.43 1.97 1.57c-2.26 2.42-5.34 3.94-8.27 4.08l-.47.01c-2.31 0-4.29-.87-5.57-2.46-1.35-1.67-1.81-3.95-1.28-6.42 1.05-4.93 7.16-9.96 12.1-9.96v-.17m-.01 0c-5.2 0-11.23 5.23-12.27 10.1-1.09 5.11 2.04 9.09 7.02 9.09.16 0 .32 0 .48-.01 3.15-.16 6.27-1.82 8.51-4.27-1.17-.99-3.09-2.41-4.05-3.24-1 1.43-2.16 2.03-3.17 2.03-1.55 0-2.77-1.4-2.6-3.42.19-2.28 1.94-4.43 3.91-4.8a2.91 2.91 0 0 1 .57-.06c1.18 0 2.1.74 2.48 1.9l5.18-3.5c-1.48-2.72-3.68-3.82-6.06-3.82z",
    fill: "#fe5"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 51.785,
    y1: 44.275,
    x2: 51.785,
    y2: 25.306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3942c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#fbb72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#fed432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe636"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m51.09 25.92 6.08-.62c-.28 1.26-2.73 12.42-3.59 14.7-.74 1.97-2.22 4.24-7.18 4.27l4.69-18.35z",
    fill: "url(#f)",
    style: {
      fillRule: "evenodd"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.06 25.4c-.38 1.71-2.73 12.35-3.56 14.57-.72 1.93-2.17 4.15-6.99 4.22l4.63-18.13 5.92-.66m.22-.19L51 25.9l-4.71 18.46c4.62 0 6.45-1.88 7.37-4.33.91-2.43 3.62-14.82 3.62-14.82z",
    fill: "#fe5"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 79.993,
    y1: 41.277,
    x2: 79.993,
    y2: 15.999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3942c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#fbb72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#fed432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe636"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.83 41.28c.37-1.64 4.52-19.73 5.82-22.47 1.24-2.61 5.97-2.79 6.72-2.81L78.3 27.98l.21-.2c1.29-1.2 5.54-5.94 5.59-5.99l7.06-.82-7.8 8.11 3.47 9.67c-.35.1-1.77.44-3.99.5h-.13c-2.26 0-3.01-1.53-3.38-2.68-.27-.84-.72-2.85-.73-2.87l-.03-.15-2.24 2.15-1.25 4.85-6.25.73z",
    fill: "url(#g)",
    style: {
      fillRule: "evenodd"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.26 16.09 78.3 27.68l-.14.56.42-.39c1.24-1.15 5.07-5.42 5.55-5.95l6.81-.81-7.63 7.94-.07.08.04.1 3.46 9.5c-.46.12-1.82.42-3.87.47h-.13c-2.2 0-2.94-1.5-3.3-2.62-.26-.83-.72-2.84-.73-2.86l-.07-.29-.22.21-2.13 2.05-.03.03-.01.05-1.2 4.7-6.09.74c.51-2.24 4.52-19.66 5.79-22.34 1.14-2.47 5.5-2.73 6.51-2.76m.2-.18c-.33 0-5.56.04-6.89 2.86-1.37 2.9-5.85 22.61-5.85 22.61l6.45-.79 1.23-4.81 2.13-2.05s.46 2.03.73 2.88c.27.84.96 2.74 3.46 2.74h.13c2.6-.07 4.09-.53 4.09-.53l-3.52-9.67 7.96-8.28-7.35.88s-4.28 4.77-5.58 5.98l3.02-11.81-.01-.01z",
    fill: "#fe5"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 39.587,
    y1: 44.73,
    x2: 39.587,
    y2: 26.309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3942c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#fbb72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#fed432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe636"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M43.97 44.73c-.28 0-.63-.14-1.06-.44-.25-.17-.45-.33-.62-.47-.74-.59-1.11-.89-3.87-.95-.25 0-.49-.01-.72-.01-1.94 0-3.02.17-3.98.32l-1.28.17c-.41.04-.77.05-1.07.05-.76 0-1.16-.09-1.19-.09.02-.01-.5-.79-.28-3.85.23-3.29 2.62-10.84 2.83-11.09.79-.06 1.96-.21 3.11-.35l2.7-.32c-.28.99-2.17 7.72-2.43 9.71-.15 1.15 0 2 .42 2.48.25.29.6.43 1.02.43.25 0 .53-.05.83-.15 1.76-.58 2.64-3.48 3.46-6.66.17-.66.31-1.25.43-1.79.48-2.09.77-3.35 2.12-4.38 1.19-.9 3.18-1.04 4.27-1.04a8.69 8.69 0 0 1 .65.02l-4.45 17.6c-.22.45-.45.81-.89.81z",
    fill: "url(#h)",
    style: {
      fillRule: "evenodd"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m48.67 26.39.55.01-4.42 17.48c-.26.49-.47.76-.83.76-.26 0-.6-.14-1.01-.42l-.61-.46c-.75-.61-1.13-.91-3.92-.97l-.73-.01c-1.95 0-3.03.17-3.99.32l-1.27.17a13.36 13.36 0 0 1-1.06.05c-.59 0-.96-.05-1.11-.08-.11-.21-.47-1.13-.28-3.77.22-3.12 2.46-10.38 2.77-10.99l3.1-.36 2.57-.31c-.38 1.34-2.15 7.64-2.4 9.61-.15 1.17 0 2.05.44 2.54.27.31.63.46 1.09.46.26 0 .54-.05.85-.15 1.8-.59 2.69-3.52 3.52-6.72.17-.66.31-1.25.43-1.79.49-2.14.77-3.32 2.09-4.33 1.17-.9 3.14-1.04 4.22-1.04m0-.17c-1.09 0-3.11.14-4.32 1.06-1.72 1.32-1.74 2.95-2.58 6.22-.85 3.27-1.74 6.05-3.41 6.6-.29.1-.56.15-.8.15-1.11 0-1.58-1.03-1.35-2.81.27-2.17 2.46-9.82 2.46-9.82l-5.99.7c-.23.18-2.63 7.92-2.85 11.14s.34 3.94.34 3.94.4.1 1.21.1c.3 0 .66-.01 1.07-.05 1.42-.13 2.42-.49 5.25-.49l.72.01c3.39.07 3.13.51 4.44 1.4.47.32.83.45 1.1.45.49 0 .74-.4.98-.85.36-.69 4.48-17.72 4.48-17.72s-.29-.03-.75-.03z",
    fill: "#fe5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.08 30.82s5.72-5.39 10.25-5.43 5.68 1.84 6.86 2.44c1.19.6 2.01.28 2.01.28s-2.29-4.79-8.28-4.14c-5.99.63-10.02 5.56-10.84 6.85zm9.15 12.13s-2.79 1.22-5.54-.39c-2.74-1.61-2.38-5.02-2.38-5.02s-1.21 2.14.59 5.13c1.81 2.99 6.5 2.23 7.21 2.03s.92-.48.78-.76c-.13-.28-.66-.99-.66-.99zm5.3 4.6s-4.3-10.5-4.23-10.94c.07-.43.68-.62.8-.51.11.11 4.21 8.82 4.41 9.28.22.47-.56 2.49-.98 2.17zm12.5-18.62s-.91-.19-1.33.46c-.41.64-2.19 7.32-1.92 8.61s.91 1.08.91 1.08l2.01-8.35c.56-1.41.33-1.8.33-1.8zm7 13.79c.16-.16 3.76-14.94 3.73-15.12-.02-.18-1.12-.21-1.71 2.07-.6 2.28-3.27 11.92-3.11 12.29.15.36.93 1.05 1.09.76zm6.43-.69 3.7-14.78c.32-.74 1.3-.67 1.3-.37s-2.91 12.62-3.2 13.6c-.29.99-1.69 1.89-1.8 1.55zm7.67-13.1s2.96-3.63 6.38-4.12 5.31.94 6 1.4c.68.46.59.69.32 1.04-.27.34-.87.41-.94.3s-1.76-2.16-5.12-1.65c-3.38.5-4.69 1.83-6.64 3.03zm.56 7.3s.5 3.36 3.73 3.61 4.87-1.91 4.87-2.07-.96-.64-.96-.64-3.75 4.23-7.64-.9zm16.77-6.31 3.11-12.29c.23-.39 1.19-.8 1.15-.34-.05.46-2.61 10.89-2.79 11.44-.19.55-1.22 1.49-1.47 1.19zm-.66 7.27c0 .25-.42 1.88-.6 2.09s-.96.76-1.15.39c-.18-.37.48-1.47.76-1.89.28-.4.92-.98.99-.59zm7.46-7.89s-.87.37-.82 1.43c.05 1.05 1.83 6.74 2.52 7.04s1.15.02 1.15.02l-2.85-8.49z",
    fill: "#fff",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 34.359,
    y1: 61.468,
    x2: 32.825,
    y2: 45.362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#2c944b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#53a24b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#7bb14b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#83b64b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a9cd4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#aed34a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M25.55 63.74c-.62 0-1.15-.03-1.59-.1l4.83-18.46c.23 0 4.86-.93 8.07-.93.77 0 1.41.05 1.89.16 3.44.76 5.11 2.69 5.11 5.9 0 3.59-2.09 8.38-6.09 10.61-3.29 1.83-8.75 2.82-12.22 2.82zm9.24-14.94c-1.07 0-1.96.17-1.97.17-.09.15-2.45 9.21-2.48 9.3l-.03.11h.3c3.72 0 5.68-1.46 6.68-2.69 1.37-1.69 1.55-3.71 1.29-4.92-.34-1.63-2.25-1.97-3.79-1.97z",
    fill: "url(#i)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.86 44.34c.77 0 1.4.05 1.87.16 3.39.75 5.04 2.65 5.04 5.82 0 3.56-2.08 8.32-6.04 10.53-3.28 1.82-8.72 2.8-12.18 2.8-.57 0-1.07-.03-1.48-.08l4.78-18.26c.71-.14 4.99-.97 8.01-.97m-6.25 14.13c3.75 0 5.74-1.48 6.74-2.72 1.39-1.71 1.57-3.76 1.31-4.99-.28-1.34-1.62-2.04-3.87-2.04-1.08 0-1.95.16-1.99.17l-.11.02-.03.1c-.02.09-2.38 9.13-2.41 9.24l-.06.21h.22l.2.01m6.25-14.3c-3.34 0-8.15.99-8.15.99l-4.85 18.55c.46.07 1.04.11 1.7.11 3.38 0 8.93-.98 12.26-2.83 3.98-2.21 6.13-6.95 6.13-10.68s-2.24-5.34-5.17-5.99c-.53-.1-1.19-.15-1.92-.15zM30.61 58.3h-.18c.02-.07 2.41-9.24 2.41-9.24s.88-.17 1.96-.17c1.5 0 3.37.33 3.7 1.91.57 2.67-1.16 7.5-7.89 7.5z",
    style: {
      fill: "#c5e54e"
    }
  }), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 49.127,
    y1: 60.039,
    x2: 47.598,
    y2: 43.988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#2c944b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#53a24b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#7bb14b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#83b64b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a9cd4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#aed34a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 60.08c-.52 0-.99-.04-1.18-.06l.68-2.63 2.82-11.05c.16-.07 2.81-.35 4.53-.51l-.75 2.6h.14c.45-.57 1.55-1.87 2.54-2.38.93-.47 1.92-.61 2.25-.65l-1.12 4.2c-.44.04-3.11.4-4.36 3.04-.93 1.97-1.14 3-1.29 3.74-.07.34-.12.61-.23.89-.34.9-1.66 2.46-2.73 2.69-.34.08-.78.12-1.3.12z",
    fill: "url(#j)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.42 45.51-1.07 4.02c-.6.07-3.15.5-4.37 3.08-.94 1.98-1.14 3.01-1.29 3.76l-.22.88c-.33.89-1.66 2.42-2.67 2.63-.36.08-.79.12-1.29.12a12.14 12.14 0 0 1-1.07-.05l.69-2.68 2.77-10.82c.43-.12 2.75-.37 4.35-.52l-.7 2.56.05.07h.09c.03 0 .09-.01.14-.07l.03-.03c.89-1.12 1.8-1.97 2.48-2.32.8-.42 1.67-.58 2.08-.63m.23-.19s-1.24.07-2.4.67c-1.17.6-2.45 2.25-2.56 2.4-.07 0 .8-2.65.8-2.65l-4.74.6c-.02.16-3.5 13.65-3.52 13.76a12.02 12.02 0 0 0 1.29.07c.43 0 .91-.03 1.32-.11 1.1-.23 2.45-1.82 2.79-2.74s.16-1.77 1.51-4.62c1.35-2.86 4.35-3 4.35-3l1.16-4.38z",
    style: {
      fill: "#c5e54e"
    }
  }), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 59.572,
    y1: 59.04,
    x2: 58.043,
    y2: 42.989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#2c944b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#53a24b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#7bb14b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#83b64b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a9cd4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#aed34a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M54.92 58.66c-1.17 0-2.11-.54-2.66-1.54-.64-1.15-.65-2.72-.02-3.73 1.13-1.81 2.77-2.87 5-3.23a10.35 10.35 0 0 1 1.67-.13c1.37 0 2.27.27 2.27.27l.07.02.03-.07c.02-.04.45-1.04.02-1.74-.25-.39-.71-.61-1.39-.63h-.25c-1.9 0-4.06.88-4.65 1.14l1.03-3.79c.17-.1 3.49-.92 5.95-.92l.87.04c1.06.11 1.85.49 2.36 1.13.59.75.81 1.84.63 3.24-.19 1.47-.52 2.63-.84 3.75l-.62 2.42-.37 2.48c-.21.05-.93.22-1.69.22-.44 0-.83-.06-1.15-.17-1.17-.4-1.67-1.09-1.67-1.1l-.08-.12-.06.13c-.01.02-1.07 2.17-4.25 2.32l-.2.01zm4.98-6.45c-1.03 0-2.38.19-2.99 1.07-.42.62-.52 1.28-.26 1.77.21.39.6.62 1.09.62.18 0 .36-.03.55-.09 1.34-.44 2.53-2.17 2.53-3.24v-.07l-.07-.01c-.01-.01-.36-.05-.85-.05z",
    fill: "url(#k)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 44.39.86.04c1.03.1 1.81.48 2.31 1.1.58.73.78 1.8.61 3.17-.19 1.47-.52 2.62-.84 3.74l-.62 2.42-.37 2.43c-.27.06-.92.2-1.61.2-.43 0-.81-.05-1.12-.16-1.14-.39-1.62-1.06-1.63-1.06l-.17-.24-.12.26c-.01.02-1.05 2.12-4.18 2.27h-.19c-1.45 0-2.21-.81-2.59-1.49-.61-1.11-.62-2.67-.02-3.64 1.12-1.79 2.73-2.84 4.94-3.19a10.23 10.23 0 0 1 1.66-.13c1.35 0 2.24.26 2.25.27l.14.04.06-.14c.02-.04.47-1.08.01-1.82-.26-.42-.75-.65-1.46-.67-.08 0-.16-.01-.25-.01-1.8 0-3.77.76-4.53 1.08l.94-3.56c.22-.11 3.45-.91 5.92-.91m-4.27 11.36c.19 0 .38-.03.58-.1 1.37-.45 2.59-2.23 2.59-3.32v-.15l-.15-.02c-.01 0-.36-.05-.86-.05-1.05 0-2.43.19-3.06 1.11-.44.64-.54 1.34-.27 1.86.23.43.65.67 1.17.67M62 44.22c-2.47 0-5.8.81-6 .94-.23.14-1.1 4-1.1 4s2.55-1.2 4.77-1.2h.24c2.26.09 1.3 2.25 1.3 2.25s-.9-.27-2.3-.27c-.5 0-1.07.04-1.68.13-2.31.37-3.94 1.47-5.06 3.27-1.1 1.76-.35 5.39 2.75 5.39.07 0 .13 0 .2-.01 3.27-.16 4.33-2.37 4.33-2.37s.5.72 1.71 1.13c.37.13.78.17 1.18.17.93 0 1.78-.24 1.78-.24s-.05-.44.37-2.53c.41-2.09 1.14-3.66 1.46-6.17s-.6-4.21-3.07-4.46l-.88-.03zm-4.27 11.36c-1.03 0-1.56-1.08-.75-2.25.61-.88 2.01-1.04 2.92-1.04l.83.04c0 .97-1.13 2.72-2.47 3.16-.19.06-.37.09-.53.09z",
    style: {
      fill: "#c5e54e"
    }
  }), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 77.323,
    y1: 57.349,
    x2: 75.793,
    y2: 41.286
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#2c944b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#53a24b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#7bb14b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#83b64b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a9cd4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#aed34a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m66.28 57.44-.07-13.43 4.29-.75-.11 6.49.08.11c.08 0 .08 0 1.19-2.11l1.72-3.22c1.2-2.23 3.9-2.4 4.7-2.4h.13l.22 7.08.15-.34c.02-.05 2.21-4.91 3.67-6.42 1.04-1.08 2.99-1.24 4.06-1.24l.53.01c-.5 1.04-4.34 8.87-6.39 11.96-1.73 2.6-4.06 2.88-4.97 2.88-.13 0-.24-.01-.3-.01L74.73 49l-.14.28c-.02.05-2.44 4.78-3.92 6.54-1.26 1.49-3.6 1.61-4.28 1.61l-.11.01z",
    fill: "url(#l)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.31 41.13v.17l.39.01c-.68 1.4-4.34 8.85-6.33 11.83-1.71 2.57-4 2.85-4.9 2.85-.09 0-.16 0-.22-.01l-.43-6.67-.04-.62-.28.55c-.02.05-2.43 4.77-3.91 6.53-1.23 1.46-3.54 1.58-4.22 1.58l-.07-13.27 4.12-.72-.11 6.36-.02.09.05.07.05.07h.08c.13 0 .13 0 1.27-2.16l1.72-3.21c1.18-2.19 3.84-2.36 4.63-2.36h.05l.2 6.63.02.74.3-.68c.02-.05 2.2-4.89 3.65-6.4 1.02-1.06 2.95-1.21 4-1.21v-.17m0 0c-1.04 0-3.05.15-4.13 1.27-1.49 1.55-3.68 6.45-3.68 6.45l-.21-6.79h-.21c-.78 0-3.54.17-4.77 2.45l-2.84 5.28c.05-.2.11-6.62.11-6.62l-4.46.78.07 13.58h.19c.68 0 3.06-.11 4.35-1.64 1.51-1.8 3.93-6.56 3.93-6.56l.44 6.81s.14.02.38.02c.91 0 3.29-.27 5.04-2.92 2.22-3.34 6.45-12.08 6.45-12.08s-.25-.03-.66-.03z",
    style: {
      fill: "#c5e54e"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.37 40.75h1.11l-.05.29h-.37l-.13.89h-.36l.13-.89h-.37l.04-.29zm1.27 0h.48l.08.72.3-.72h.48l-.18 1.18h-.3l.13-.9-.37.9h-.27l-.09-.9-.13.9h-.3l.17-1.18z",
    fill: "#7bb14b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1f1f1f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46.77 70.42 3.23-.41.31-.95-2.26.32 1.39-4.65-1.01.13zm-.17-2.84.81-2.59-1.1.14-.68 2.21c-.26.83-.59 2.35-1.57 2.59-1.76.43-.07-3.69.23-4.54l-1.14.15c-.5 1.48-2.6 5.99.61 5.47 1.88-.3 2.37-1.9 2.84-3.43zm-9.87 3.93h1.01c3.59.17 4.59-3.04 2.92-3.1.46-.32 1.67-1.33 1.17-2.06-.49-.72-2.88-.3-3.41-.32l-1.69 5.48zm1.28-.92.37-1.19c2.49-.96 2.12 1.19-.37 1.19zm.68-2.19.35-1.12c1.86-1 2.43.62-.35 1.12zm12.13 1.53 3.12-.41.31-.95-2.15.29 1.38-4.65-1.01.13-1.65 5.59zm17.52-2.25 3.25-.42.32-.95-2.27.31.45-1.5 1.9-.25.33-.95-1.95.26.38-1.28 2.02-.28.32-.95-3.06.37zm-9.03 1.14 3.25-.37.32-.95-2.27.28.44-1.49 1.92-.23.31-.94-1.94.23.38-1.28 2.03-.24.31-.94-3.06.31zm9.92-6.65-2.89 3.78-.63 2.07-1.01.13h-.04l.74-2.38-.51-3.04 1-.13.25 2.11h.2l1.51-2.36zm-14.32 7.04.2-.92s2.34.32 2.52-.65c.19-.96-1.52-.54-1.7-1.94s1.08-1.96 2-2.15c.91-.18 1.78-.05 1.78-.05l-.3 1.13s-2.22-.24-2.15.75 1.8.47 1.73 1.9-1.93 2.23-4.08 1.93z",
    style: {
      fillRule: "evenodd"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m26.19 73.07-.15-2.57.65-.09.05 1.69.87-1.81.65-.09-.01 1.7.91-1.82.66-.09-1.47 2.79-.64.08-.02-1.67-.85 1.78-.65.1zm4.08-3.48.16-.66.67-.09-.16.65-.67.1zm-.74 3.04.65-2.68.67-.09-.66 2.68-.66.09zm3.17-3.02-.14.56-.46.06-.26 1.08-.08.38c0 .04.01.06.04.08s.06.03.1.02c.06-.01.16-.04.29-.1l-.07.54c-.18.09-.36.15-.56.18-.12.02-.22.01-.31-.02-.08-.03-.14-.07-.17-.14-.03-.06-.04-.15-.03-.27.01-.08.04-.25.1-.5l.29-1.17-.31.04.14-.56.31-.04.13-.53.77-.51-.23.95.45-.05zm1.39-1.17-.33 1.36c.28-.29.57-.46.87-.51.16-.02.29-.01.39.04.11.05.19.11.22.2a.54.54 0 0 1 .05.29c-.01.11-.04.29-.09.53l-.38 1.57-.67.09.34-1.41c.07-.28.1-.46.09-.53s-.04-.13-.09-.16c-.06-.04-.13-.05-.23-.04-.11.02-.22.06-.32.13s-.19.17-.26.29-.13.29-.18.52l-.33 1.35-.67.09.9-3.7.69-.11z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M79.16 56.85c4.22 0 7.26 3.61 6.8 8.06s-4.25 8.05-8.47 8.05c-1.81 0-3.4-.66-4.6-1.77l1.16-1.27c.9.78 2.05 1.24 3.35 1.24 3.27 0 6.2-2.91 6.56-6.5s-2-6.5-5.27-6.5c-2.03 0-3.93 1.13-5.17 2.84l-1.5.04c1.57-2.5 4.25-4.19 7.14-4.19zm-1.23 3.7c2.11 0 3.63 1.84 3.4 4.11s-2.13 4.11-4.24 4.11c-.6 0-1.14-.15-1.62-.41l1.33-1.46c.06 0 .11.01.17.01 1.16 0 2.21-1.01 2.33-2.27.13-1.25-.71-2.27-1.87-2.27s-2.21 1.01-2.33 2.27c-.03.26-.01.51.04.75l-1.26 1.05c-.19-.54-.26-1.14-.19-1.78.23-2.27 2.13-4.11 4.24-4.11zm-7.8 10.84 7.05-7.41.73.73-6.79 7.41.02 1.96-2.18 2.83-.22-2.23-.76-.94-1.92-.16 2.45-2.29z",
    fill: "#ad1d26",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaNjQuickDraw);
export default __webpack_public_path__ + "static/media/usa_nj_quick_draw.db62615618fa3a7cf2cfbcf982d440ae.svg";
export { ForwardRef as ReactComponent };